import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ThisDriversCurrentFines from './this-drivers-current-fines.jsx';
import ThisDriversArchivedFines from './this-drivers-archived-fines.jsx';

export default class DriverFine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: props.data || [],
      expanded: false,
      newFineFormVisible: false,
      play: false,
      selected_start_date:null,
      selected_end_date:null
    };

    this.handleButtonClicked = this.handleButtonClicked.bind(this);
    this.handleAddNewFineFormSubmitButtonClick = this.handleAddNewFineFormSubmitButtonClick.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleTotalAmountUpdate = this.handleTotalAmountUpdate.bind(this);
    this.handlePaidAmountUpdate = this.handlePaidAmountUpdate.bind(this);
  }

  handleButtonClicked(variable) {
    $("#driver-expanded-fines-list-"+variable).slideToggle(200);
    this.setState({expanded: !this.state.expanded})
  }
  handleStartDateChange(date) {
    this.setState({selected_start_date: date})
  }
  handleEndDateChange(date) {
    this.setState({selected_end_date: date})
  }

  handleAddNewFineButtonClick() {
    this.setState({
      newFineFormVisible: !this.state.newFineFormVisible
    });
  }

  handleAddNewFineFormSubmitButtonClick(e) {
    e.preventDefault();
    let that = this;
    let addNewExcessData = {
      api_token: window.api_token,
      driver_id: this.state.data.driver.id,
      description: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=description]'
      ).val(),
      insurance_reference: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=insurance_reference]'
      ).val(),
      original_amount_to_repay: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=original_amount_to_repay]'
      ).val(),
      deduction_occurance: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=deduction_occurance]'
      ).val(),
      agreed_deduction_amount: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=agreed_deduction_amount]'
      ).val(),
      start_date: (moment(this.state.selected_start_date).isValid()) ? moment(this.state.selected_start_date).format("YYYY-MM-DD"):null,
      end_date: (moment(this.state.selected_end_date).isValid()) ? moment(this.state.selected_end_date).format("YYYY-MM-DD") : null
    };

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/drivers/fines/add-new-fine',
      data: addNewExcessData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status == 200) {
          $('#infomodallabel').html('New Fine Created');
          $('#infomodal .modal-body').html('New Fine Created');
          $('#infomodal').modal();
          $('input').val('');
          $('textarea').val('');
          $('select').val('');
          
          that.handleAddNewFineButtonClick();
          that.accessChild();
          let total = parseInt(that.state.data.fine_total_amount) + parseInt(addNewExcessData.original_amount_to_repay);
          that.state.data.fine_total_amount = total;
          that.setState({data:that.state.data});
        }
        else {
          $('#infomodallabel').html('Error adding new fine');
          $('#infomodal .modal-body').html($.parseHTML(
            response.responseText.
            replace(/\"/g, ""))
          );
          $('#infomodal').modal();
        }
      }
    });
  }
  handleTotalAmountUpdate(total){
    this.state.data.fine_total_amount = total;
    this.setState({data:this.state.data});
  }
  handlePaidAmountUpdate(total){
    this.state.data.fine_total_paid_amount = total;
    this.setState({data:this.state.data});
  }
  accessChild(){
    this.refs.child.handleFineTableRefresh();
    this.refs.child.handleFineTableRefresharc();
  }
  componentDidMount() {
    this.setState({
      play: true
    });
  }


  render() {
    return (
      <div className={"driver-fine-account-container"+
      (this.state.expanded ? ' fine-container-expanded ' : '')}>
         <div
          className="row"
          onDoubleClick={() => {
              this.handleButtonClicked(this.state.data.id)
          }}>
          <div className="col-md-1 text-left">
            <img
              src={"/user-images/"+this.state.data.id}
              className="driver-fines-table-driver-image"
            />
          </div>

          <div className="col-md-4">
            <h3>
              <a href={"/portal-admin/users/view/"+this.state.data.id}>
                {this.state.data.first_name} {this.state.data.last_name}
              </a>
            </h3>
          </div>

          <div className="col-md-5">
            <h3>
            &pound;{this.state.data.fine_total_paid_amount} /
            &pound;{this.state.data.fine_total_amount}
            </h3>
          </div>

          <div className="col-md-2 text-right">
            <button
              onClick={(e) => {
                this.handleButtonClicked(this.state.data.id)
              }}
              className="btn btn-lg btn-default">
              Fines {(this.state.expanded ?
                <i className="fa fa-times"></i>:
                <i className="fa fa-level-down-alt"></i>)}
            </button>
          </div>
        </div>

        <div
          className="container driver-expanded-fines-list"
          id={"driver-expanded-fines-list-"+this.state.data.id}>
          <div className="row">
          <div className="col-md-6">
          <div className="row">
          <div className="col-md-6">
            <h2>Current Fines</h2>
          </div>
          <div className="col-md-6">
          <button className="btn btn-sm btn-dark"
               onClick={(e) => {
                 this.handleAddNewFineButtonClick(this.state.data.id)
               }}>
              {(this.state.newFineFormVisible ?
                <i className="fa fa-minus"></i>:
                <i className="fa fa-plus"></i>)
              } Add New Fine
              </button>
            </div>
            </div>

          {(this.state.newFineFormVisible ?
            <Animate
              play={this.state.play}
              start={{opacity: 0}}
              end={{opacity: 1}}
              className="driver-excess-form-container"
            >
            <form id={"new_excess_for_user"+this.state.data.id}>
              <fieldset>
                  <div className="row">
                    <div className="col-md-6 text-right">
                      Description
                    </div>
                    <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="description"
                    type="text" placeholder="description" />
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6 text-right">
                    Reference
                    </div>
                    <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="insurance_reference"
                    type="text" placeholder="reference" />
                    </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 text-right">
                        Amount to Repay:
                      </div>
                      <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="original_amount_to_repay"
                     type="text" placeholder="&pound;amount" />
                   </div>
                    </div>
                <div className="row">
                    <div className="col-md-6 text-right">
                    @
                    </div>
                    <div className="col-md-6 text-left">
                      <input type="text" placeholder="&pound;amount"
                      name="agreed_deduction_amount"
                      className="form-control" />
                     per <select name="deduction_occurance">
                      <option value="weekly">Week</option>
                      <option value="monthly">Month</option>
                      <option value="daily">Day</option>
                      <option value="hourly">Hour</option>
                    </select><br />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 text-right">
                        Start Date:
                    </div>
                    <div className="col-md-6 text-left">
                        <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleStartDateChange} selected={this.state.selected_start_date}/>
                   </div>
                </div>
                <div className="row">
                    <div className="col-md-6 text-right">
                        End Date:
                    </div>
                    <div className="col-md-6 text-left">
                        <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleEndDateChange} selected={this.state.selected_end_date}/>
                   </div>
                </div>
                <div className="row">
                    <div className="col-md-6 text-right">&nbsp;</div>
                    <div className="col-md-6 text-left">
                    <button className="btn btn-sm btn-primary"
                      onClick={(e) => {
                        this.handleAddNewFineFormSubmitButtonClick(e)
                      }}>
                      <i className="fa fa-plus"></i> Add New Fine</button>
                    </div>
                </div>
              </fieldset>
            </form>
          </Animate>
          :'')}

            <ThisDriversCurrentFines
               fineAccountId={
                 this.state.data.driver.fine_account_id
               }
               handleTotalAmountUpdate={this.handleTotalAmountUpdate}
               handlePaidAmountUpdate={this.handlePaidAmountUpdate}
               ref="child"
             />
          </div>

          <div className="col-md-6">
            <h2>Archived Fines</h2>
            <ThisDriversArchivedFines
              fineAccountId={
                this.state.data.driver.fine_account_id
              }
               handleTotalAmountUpdate={this.handleTotalAmountUpdate}
               handlePaidAmountUpdate={this.handlePaidAmountUpdate}
               ref="child"
            />
          </div>
          </div>
        </div>
      </div>
    );
  }
}
